/* --------------------------------------------------------------------------
   Homellence · Filterzeile der Kollektionsseite

   Filtert rein im Browser über das Attribut data-room an der Karte.
   Kein Nachladen, kein Seitenwechsel. Ohne JavaScript sind alle Karten
   sichtbar - die Zeile wird dann schlicht nicht bedienbar.

   F1 (Runde 36) · Dazu gekommen sind die Filter und die Sortierung von
   Shopify. Die sind etwas anderes: Sie wirken auf **alle** Seiten der
   Liste, nicht nur auf die angezeigten Karten, und muessen deshalb ueber
   den Server gehen. Beide Teile stehen hier nebeneinander, weil sie sich
   eine Ergebniszeile teilen.
   -------------------------------------------------------------------------- */

(function () {
  'use strict';

  function setUp(bar) {
    var scope = bar.closest('.hl-collection') || document;
    var grid = scope.querySelector('[data-hl-collection-grid]') || scope.querySelector('.hl-collection__grid');
    if (!grid) return;

    var cells = Array.prototype.slice.call(grid.querySelectorAll('[data-hl-collection-cell]'));
    var notes = Array.prototype.slice.call(grid.querySelectorAll('.hl-collection__note'));
    var empty = scope.querySelector('[data-hl-collection-empty]');
    var buttons = Array.prototype.slice.call(bar.querySelectorAll('[data-hl-filter]'));

    /* Gebaenderte Ansicht: dann werden ganze Gruppen aus- und eingeblendet
       statt einzelner Karten. */
    var groups = Array.prototype.slice.call(scope.querySelectorAll('[data-hl-collection-group]'));

    function applyToGroups(handle) {
      var shown = 0;
      groups.forEach(function (group) {
        var show = handle === 'all' || group.getAttribute('data-hl-collection-group') === handle;
        group.hidden = !show;
        if (show) shown += group.querySelectorAll('[data-hl-collection-cell]').length;
      });
      return shown;
    }

    function applyToCells(handle) {
      var shown = 0;
      cells.forEach(function (cell) {
        var rooms = (cell.getAttribute('data-room') || '').split(/\s+/);
        var show = handle === 'all' || rooms.indexOf(handle) !== -1;
        cell.hidden = !show;
        if (show) shown += 1;
      });

      /* Der Einschub gehoert zum vollstaendigen Raster. Sobald gefiltert
         wird, stimmt seine Position zwischen den Reihen nicht mehr - dann
         bleibt er weg. */
      notes.forEach(function (note) {
        note.hidden = handle !== 'all';
      });

      return shown;
    }

    function apply(handle) {
      var shown = groups.length ? applyToGroups(handle) : applyToCells(handle);

      if (empty) empty.hidden = shown !== 0;

      /* F1 (Runde 36) - Die Ergebniszeile gehoert zu den Shopify-Filtern,
         zaehlt aber die **sichtbaren** Karten. Blendet ein Raum-Chip welche
         aus, muss sie mitgehen; sonst stuende ueber drei Karten weiter
         "23 Produkte". */
      zaehlerSetzen(scope, shown);

      buttons.forEach(function (button) {
        button.setAttribute('aria-pressed', button.getAttribute('data-hl-filter') === handle ? 'true' : 'false');
      });
    }

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        apply(button.getAttribute('data-hl-filter'));
      });
    });
  }

  /* ======================================================================
     F1 (Runde 36) - Filter und Sortierung von Shopify

     Unten liegt ein gewoehnliches GET-Formular. Ohne dieses Skript fuehrt
     der Knopf "Anwenden" zu einem Seitenwechsel, und alles funktioniert.
     Mit Skript wird derselbe Zielweg genommen, aber nur die Sektion
     nachgeladen: `?section_id=` liefert genau diesen Abschnitt, der Rest
     der Seite bleibt stehen. Die Adresszeile wandert per `replaceState`
     mit, damit Neuladen und Weitergeben die gleiche Auswahl zeigen.
     ====================================================================== */

  var laufend = null;

  function wurzelVon(knoten) {
    return knoten.closest ? knoten.closest('[data-hl-facets]') : null;
  }

  function zaehlerSetzen(bereich, anzahl) {
    var feld = bereich.querySelector('[data-hl-facets-count]');
    if (!feld) return;
    var muster = anzahl === 1 ? feld.getAttribute('data-one') : feld.getAttribute('data-other');
    if (!muster) return;
    feld.textContent = muster.replace('[count]', anzahl);
  }

  /* Die Adresse entsteht aus dem Formular selbst, nicht aus einer zweiten
     Liste daneben. Leere Preisfelder fallen weg - `filter.v.price.gte=`
     ohne Wert wuerde Shopify als 0 lesen und den Filter aktiv erscheinen
     lassen. Die Standardsortierung faellt ebenfalls weg, damit die Adresse
     ohne Auswahl wieder die blanke Kollektionsadresse ist. */
  function adresseAus(formular, wurzel) {
    var daten = new FormData(formular);
    var standard = wurzel.getAttribute('data-default-sort');
    var teile = [];

    daten.forEach(function (wert, name) {
      var text = String(wert).trim();
      if (text === '') return;
      if (name === 'sort_by' && text === standard) return;
      teile.push(encodeURIComponent(name) + '=' + encodeURIComponent(text));
    });

    var basis = formular.getAttribute('action') || window.location.pathname;
    return teile.length ? basis + '?' + teile.join('&') : basis;
  }

  /* Nach dem Austausch ist das alte Bedienelement fort. Gemerkt wird
     deshalb ein Weg dorthin, nicht das Element: Name und Wert reichen, weil
     beide im neuen Abschnitt gleich lauten. Bei Textfeldern kommt die
     Schreibmarke mit, sonst spraenge sie ans Ende. */
  function fokusMerken() {
    var el = document.activeElement;
    if (!el || !el.name) return null;
    var weg = el.tagName.toLowerCase() + '[name="' + el.name + '"]';
    if (el.type === 'checkbox' || el.type === 'radio') {
      weg += '[value="' + el.value + '"]';
    }
    var merker = { weg: weg };
    try {
      if (el.type === 'number' || el.type === 'text') {
        merker.start = el.selectionStart;
        merker.ende = el.selectionEnd;
      }
    } catch (e) {
      /* Zahlenfelder geben in manchen Browsern keine Schreibmarke her. */
    }
    return merker;
  }

  /* Ein aufgeklappter Filter muss aufgeklappt bleiben.

     Gemessen am 17.09.: Ohne das klappte die Gruppe bei jeder Aenderung zu -
     und der Fokus ging verloren, weil ein Feld in einem geschlossenen
     `details` nicht fokussierbar ist. Wer mit der Tastatur zwei Werte
     anhaken will, stand nach dem ersten wieder am Seitenanfang. */
  function gruppenMerken(bereich) {
    var offen = [];
    Array.prototype.forEach.call(bereich.querySelectorAll('[data-hl-facet-group]'), function (gruppe) {
      if (gruppe.open) offen.push(gruppe.getAttribute('data-hl-facet-group'));
    });
    return offen;
  }

  function gruppenZurueck(offen, bereich) {
    if (!offen || !offen.length) return;
    Array.prototype.forEach.call(bereich.querySelectorAll('[data-hl-facet-group]'), function (gruppe) {
      if (offen.indexOf(gruppe.getAttribute('data-hl-facet-group')) !== -1) gruppe.open = true;
    });
  }

  function fokusZurueck(merker, bereich) {
    if (!merker) return;
    var ziel = bereich.querySelector(merker.weg);
    if (!ziel) return;
    ziel.focus();
    if (merker.start == null) return;
    try {
      ziel.setSelectionRange(merker.start, merker.ende);
    } catch (e) {
      /* siehe oben */
    }
  }

  function laden(adresse, wurzel) {
    var id = wurzel.getAttribute('data-section-id');
    var ziel = document.getElementById('hl-collection-' + id);
    if (!ziel) {
      window.location.assign(adresse);
      return;
    }

    var merker = fokusMerken();
    var offeneGruppen = gruppenMerken(ziel);
    var hoehe = window.scrollY;

    if (laufend) laufend.abort();
    laufend = new AbortController();
    wurzel.setAttribute('aria-busy', 'true');

    var trenner = adresse.indexOf('?') === -1 ? '?' : '&';
    var abfrage = adresse + trenner + 'section_id=' + encodeURIComponent(id);

    window
      .fetch(abfrage, { signal: laufend.signal })
      .then(function (antwort) {
        if (!antwort.ok) throw new Error('HTTP ' + antwort.status);
        return antwort.text();
      })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var neu = doc.getElementById('hl-collection-' + id);
        if (!neu) throw new Error('Abschnitt fehlt in der Antwort');

        ziel.innerHTML = neu.innerHTML;
        window.history.replaceState({}, '', adresse);

        /* Die Raum-Chips sind neue Elemente und brauchen ihre Verdrahtung
           wieder. Die Facetten selbst laufen ueber Ereignisse am Dokument
           und muessen nicht neu angemeldet werden. */
        init();

        /* Reihenfolge: erst aufklappen, dann Fokus. Andersherum liefe der
           Fokus in ein noch geschlossenes `details`. */
        gruppenZurueck(offeneGruppen, ziel);
        window.scrollTo(0, hoehe);
        fokusZurueck(merker, ziel);
      })
      .catch(function (fehler) {
        if (fehler && fehler.name === 'AbortError') return;
        /* Geht das Nachladen schief, bleibt der gewoehnliche Seitenwechsel.
           Lieber ein Sprung als eine Seite, die nicht reagiert. */
        window.location.assign(adresse);
      })
      .then(function () {
        var jetzt = document.getElementById('hl-collection-' + id);
        var frisch = jetzt ? jetzt.querySelector('[data-hl-facets]') : null;
        if (frisch) frisch.removeAttribute('aria-busy');
      });
  }

  function absenden(wurzel) {
    var formular = wurzel.querySelector('[data-hl-facets-form]');
    if (!formular) return;
    laden(adresseAus(formular, wurzel), wurzel);
  }

  /* Preisfelder erst nach einer Ruhepause: Wer "60" tippt, meint nicht
     zuerst "6". 500 ms sind die Vorgabe aus der Anleitung. */
  var preisUhr = null;

  function facettenBinden() {
    document.addEventListener('change', function (ereignis) {
      var wurzel = wurzelVon(ereignis.target);
      if (!wurzel) return;
      if (ereignis.target.hasAttribute('data-hl-facets-price')) return;
      if (!ereignis.target.closest('[data-hl-facets-form]')) return;
      absenden(wurzel);
    });

    document.addEventListener('input', function (ereignis) {
      if (!ereignis.target.hasAttribute || !ereignis.target.hasAttribute('data-hl-facets-price')) return;
      var wurzel = wurzelVon(ereignis.target);
      if (!wurzel) return;
      window.clearTimeout(preisUhr);
      preisUhr = window.setTimeout(function () {
        absenden(wurzel);
      }, 500);
    });

    document.addEventListener('submit', function (ereignis) {
      var formular = ereignis.target;
      if (!formular.hasAttribute || !formular.hasAttribute('data-hl-facets-form')) return;
      var wurzel = wurzelVon(formular);
      if (!wurzel) return;
      ereignis.preventDefault();
      absenden(wurzel);
    });

    /* Chips zum Entfernen und der Link zum Zuruecksetzen sind echte Links.
       Ohne Skript fuehren sie zu einer neuen Seite, mit Skript nehmen sie
       denselben Weg wie das Formular. */
    document.addEventListener('click', function (ereignis) {
      var link = ereignis.target.closest ? ereignis.target.closest('[data-hl-facets-link]') : null;
      if (!link) return;
      var wurzel = wurzelVon(link) || document.querySelector('[data-hl-facets]');
      if (!wurzel) return;
      ereignis.preventDefault();
      laden(link.getAttribute('href'), wurzel);
    });
  }

  /* Der Knopf "Anwenden" gehoert dem Weg ohne Skript. Lief das Skript an,
     verschwindet er - und die Schublade am Handy wird zur Schublade. Beides
     haengt an derselben Klasse, damit es nur einen Schalter dafuer gibt. */
  function facettenAnmelden() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-hl-facets]'), function (wurzel) {
      wurzel.classList.add('hl-facets--js');
    });
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-hl-collection-filter]'), setUp);
    facettenAnmelden();
  }

  facettenBinden();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
